
import React from 'react';

const NotAuthenticatedState: React.FC = () => {
  return (
    <div className="text-muted-foreground text-center p-4">
      <p>Please sign in to access Copilot assistants</p>
    </div>
  );
};

export default NotAuthenticatedState;
